import fetchHandler from './Handler';

export const ContactusApi = async (data: any) => {
	try {
		const response = await fetchHandler({
			method: 'POST',
			endpoint: '/contactus',
			data,
		});
		return response;
	} catch (error) {
		console.error('Unexpected error:', error);
	}
};
export const bookusApi = async (data: any) => {
	try {
		const response = await fetchHandler({
			method: 'POST',
			endpoint: '/booking',
			data,
		});
		return response;
	} catch (error) {
		console.error('Unexpected error:', error);
	}
};
export const customizedMenuAPI = async (data: any) => {
	try {
		const response = await fetchHandler({
			method: 'POST',
			endpoint: '/user/quotation/sendemail',
			data,
		});
		return response;
	} catch (error) {
		console.error('Unexpected error:', error);
	}
};
export const upcommingEventsAPI = async () => {
	try {
		const response = await fetchHandler({
			method: 'GET',
			endpoint: '/user/ourevents',
		});
		return response;
	} catch (error) {
		console.error('Unexpected error:', error);
	}
};
